(function () {
    var CIRC = '<svg class="circ" viewBox="0 0 300 80" preserveAspectRatio="none" aria-hidden="true">' +
      '<path pathLength="1" d="M297,11 C262,1 92,2 39,18 C4,30 1,50 45,63 C96,77 216,79 265,64 C295,54 299,38 268,25 C247,17 200,13 160,12"/></svg>';
    document.querySelectorAll('em').forEach(function (el) {
      if (!el.querySelector('.circ')) el.insertAdjacentHTML('beforeend', CIRC);
    });
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('drawn'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('em').forEach(function (el) { obs.observe(el); });
    document.querySelectorAll('.acc2 > button').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.parentElement.classList.toggle('open');
        b.querySelector('i').textContent = open ? '−' : '+';
      });
    });
  })();
;
(function () {
  var BASE = [
    ['M', 297, 11], ['C', 262, 1, 92, 2, 39, 18], ['C', 4, 30, 1, 50, 45, 63],
    ['C', 96, 77, 216, 79, 265, 64], ['C', 295, 54, 299, 38, 268, 25],
    ['C', 247, 17, 200, 13, 160, 12]
  ];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rebuild(svg) {
    var w = svg.clientWidth || svg.getBoundingClientRect().width;
    var h = svg.clientHeight || svg.getBoundingClientRect().height;
    if (!w || !h) return;
    var sx = w / 300, sy = h / 80;
    var d = BASE.map(function (seg) {
      var cmd = seg[0], out = [cmd];
      for (var i = 1; i < seg.length; i += 2) {
        out.push((seg[i] * sx).toFixed(1) + ',' + (seg[i + 1] * sy).toFixed(1));
      }
      return out.join(' ');
    }).join(' ');
    svg.setAttribute('viewBox', '0 0 ' + w.toFixed(0) + ' ' + h.toFixed(0));
    svg.removeAttribute('preserveAspectRatio');
    var path = svg.querySelector('path');
    path.removeAttribute('pathLength');
    path.setAttribute('d', d);
    path.style.vectorEffect = 'none';
    var len = path.getTotalLength();
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = reduce ? 0 : len;
    return path;
  }

  function start() {
    var rings = [];
    document.querySelectorAll('svg.circ').forEach(function (svg) {
      var path = rebuild(svg);
      if (path) rings.push({ svg: svg, path: path });
    });
    run(rings);
  }

  function run(rings) {
    if (reduce || !rings.length) return;

    function draw(r) {
      r.path.style.transition = 'stroke-dashoffset 0.9s cubic-bezier(0.65, 0, 0.35, 1) 0.1s';
      r.path.style.strokeDashoffset = 0;
    }
    if (!('IntersectionObserver' in window)) { rings.forEach(draw); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var hit = rings.find(function (r) { return r.svg === en.target; });
        if (hit) { draw(hit); io.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    rings.forEach(function (r) { io.observe(r.svg); });
  }

  // measure only after the embedded fonts have laid out, or the ellipse is
  // built against pre-font metrics and gets stretched by the reflow. Timers
  // rather than requestAnimationFrame: rAF never fires in a hidden tab.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { setTimeout(start, 60); });
  } else {
    window.addEventListener('load', function () { setTimeout(start, 60); });
  }
})();